/** @format */

import {ActionColumn} from './action_column';
import {Table} from '@sttark/design-system';
import {NameColumn} from './name_column';
import {Toast} from '@sttark/design-system';
import React from 'react';

export const PaymentProfilesList = props => {
    const {paymentProfiles} = props;

    const [toast, setToast] = React.useState({
        isOpen: false,
        isDanger: false,
        message: ''
    });

    const handleSuccessfulPaymentProfileRemove = () => {
        setToast({
            message: 'Payment profile removed successfully',
            isDanger: false,
            isOpen: true
        });
    };

    const handleSuccessfulPaymentProfileSave = () => {
        setToast({
            message: 'Payment profile saved successfully',
            isDanger: false,
            isOpen: true
        });
    };

    const hideToast = () => {
        setToast({
            isDanger: false,
            isOpen: false,
            message: ''
        });
    };

    if (!paymentProfiles.length) {
        return <React.Fragment></React.Fragment>;
    }

    return (
        <>
            <Toast
                danger={toast.isDanger}
                autoHideDuration={4000}
                isOpen={toast.isOpen}
                onClose={hideToast}
                zIndex={3001}
                autoHide>
                <p className="color-structure-white m-0">{toast.message}</p>
            </Toast>
            <Table
                columns={[
                    {
                        title: 'Company/ Name',
                        index: 'name',
                        key: 'name'
                    },
                    {
                        index: 'action',
                        key: 'action',
                        title: ''
                    }
                ]}
                rows={paymentProfiles.map(profile => {
                    return {
                        name: <NameColumn paymentProfile={profile} />,
                        action: (
                            <ActionColumn
                                onSuccessfulRemove={handleSuccessfulPaymentProfileRemove}
                                paymentProfile={profile}
                            />
                        ),
                        key: profile.id
                    };
                })}
            />
        </>
    );
};
